import { Grid, styled } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLocales } from 'src/locales';
import { paper } from '../../theme/css';

// ----------------------------------------------------------------------

const config = [
  { step: 1, content: 'Sign up to WALK UP. Download one of our free apps to get started!', key: 'walkup_lang_011' },
  { step: 2, content: 'Purchase your favorite NFT, WALK UP and start exercise.', key: 'walkup_lang_012' },
  { step: 3, content: 'Walk, jog, or run to increase your step count ', key: 'walkup_lang_013' },
  {
    step: 4,
    content: 'Using $WUT to spend on WALK UP Ecosystem with your favourite retailers and brands to earn $WUT cashback rewards.',
    key: 'walkup_lang_014',
  },
];

// ----------------------------------------------------------------------

const StyledCard = styled(Card)(({ theme }) => ({
  ...paper({ theme, bgcolor: theme.palette.background.default }),

  height: '100%',

  padding: 20,
}));

function HomeHotItWork() {
  const { t } = useLocales();

  return (
    <Container sx={{ py: { xs: 5, md: 10 } }} id="how-it-work">
      <Stack spacing={6}>
        <Box>
          <Typography variant="h2" color="primary" textTransform="uppercase">
            {t('walkup_lang_001')}
          </Typography>

          <Typography variant="h6" color="text.secondary">
            {t('walkup_lang_010')}
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {config.map((item, index) => (
            <Grid key={index} item xs={12} sm={6} md={3}>
              <StyledCard sx={{ position: 'relative' }}>
                <Typography variant="h1" color="primary">
                  {index + 1}
                </Typography>

                <Box height={40} />

                <Stack>
                  <Typography variant="h6" fontWeight="400" fontFamily="Roboto">
                    {t(item.key)}
                  </Typography>
                </Stack>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Container>
  );
}

export default HomeHotItWork;
